<section *ngIf="processing">
  <h2>{{processingMessage}}...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<section *ngIf="!processing">
  <!-- Action Buttons -->
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate Household Exceedance Letter [{{household.id}}] Retest: <span *ngIf="parameterResult.isRetest">Yes.</span> <span
          *ngIf="!parameterResult.isRetest"> No.</span>
      </h2>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button type="submit" name="SubmitButton" (click)="onSubmitKendo()" mat-raised-button color="primary" value="Save" title="Save" [disabled]="!canSave">Save</button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
    </div>
  </div>
  <hr />
</section>



<mat-dialog-content id="householdLetterPdf">
  <div class="print-outer">
    <div class="print-inner">
      <kendo-pdf-export #pdf paperSize="letter" paperSize="A4" margin="2cm" [scale]="0.4" forcePageBreak=".page-break">
        <ng-container [ngTemplateOutlet]="kendoTemplate" [ngTemplateOutletContext]="{export: true}">
        </ng-container>
      </kendo-pdf-export>
    </div>
  </div>

  <ng-template #kendoTemplate let-export="export">

    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=latin-1">
    </head>

    <style>
      .english-text {
        font-family: 'SpanishLatin', 'SpanishLatinBold';
        font-size: 20pt;
      }

      kendo-pdf-export {
        font-family: 'SpanishLatin', 'SpanishLatinBold';
        font-size: 20pt;
      }
    </style>

    <!-- 0-5 Nitrate English .-->
    <section *ngIf="nitrateLevel < 5">
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        table {
          border: none !important;
        }

        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="english-text">
        <p>
          {{today | date: 'MMMM d, y':'':'' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>Dear <span style='color:green; '>{{household?.contactName}}</span>:</p>

        <p>
          Thank you for taking the time to learn about the safety of your domestic well water. The groundwater in parts of
          northern Morrow and Umatilla Counties is contaminated with nitrate at levels that can harm health. People can
          become exposed to nitrate when they use contaminated well water for drinking and cooking. Bottle-fed babies and
          pregnant women may suffer harm even from short exposures, and everyone may experience harm from long-term
          exposure. The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>

        <p>
          We have received results for the well providing water for: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          <span>
            We are happy to report that your test results for nitrate from the water sample collected on
            {{parameterResult.createdDate | date: 'MMMM d, y':'':'' }}

            <span *ngIf="parameterResult.nitrateNd">
              had no detectable nitrate
            </span>

            <span *ngIf="!parameterResult.nitrateNd">
              came in at {{parameterResult.nitrateDisplay}} milligrams per liter of water (mg/L)
            </span>

            which is well below the Environmental Protection Agency (EPA) limit of 10 milligrams per liter (mg/L).
            <strong>Your water's nitrate level is safe for drinking, cooking and all other uses. </strong>
          </span>
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            We also have results for your well about arsenic, total coliform and E. coli (types of bacteria) and lead.
            If any of these results are above the health limit set by EPA, we are including a fact sheet for that substance.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Your test showed that your water sample had no detectable <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>above</strong> the EPA limit of 0.010 mg/L. Please see the
              attached arsenic fact sheet.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Your test showed that your water sample had no detectable <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>above</strong> the EPA limit of 0.015 mg/L. Please see the attached
              lead fact sheet.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>found</strong> in your water sample. This test can easily pick up bacteria during the sample collection
              process and might not represent well contamination. We recommend you contact a lab to repeat the test for confirmation at your own expense. Please see the attached coliform bacteria fact
              sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>found</strong> in your water sample. This test can easily pick up bacteria during the sample collection process and
              might not represent well contamination. We recommend you contact a lab to repeat test for confirmation at your own expense. Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            Your test results also reflect that your water was tested for <strong>manganese</strong>, <strong>iron</strong> and <strong>hardness</strong>. We need this information to help decide the
            best water treatment system to reduce nitrate, should one be needed. These do not carry any health risks.
          </p>
        </span>
        <p *ngIf="!parameterResult.isRetest">

          Nitrate and other contaminant levels in groundwater will change over time. As with any private well, we
          recommend that you <strong>repeat testing</strong> of your well once per year for nitrate and other contaminants
          to monitor any changes. For arsenic, the recommendation is for every three years. Based on these results, your household
          is eligible to receive a free annual certified laboratory test by either collecting your own water sample using a kit we
          will provide for you and turning it into a designated collection site, or by requesting assistance to collect the water
          if you cannot collect it yourself. OHA will pay for <u>nitrate</u> retesting only; you would be responsible to test for other contaminants.
          After the sample is submitted to the lab, you will receive a copy of your test result from the lab, and a letter from OHA stating the result.
          If you don't receive your results after 30 days, please contact us so we can get the result to you.
          <br />

        </p>
        <p *ngIf="parameterResult.isRetest">
          Nitrate and other contaminant levels in groundwater will change over time. As with any private well, we recommend that you repeat testing of your
          well once per year for nitrate and other contaminants to monitor any changes. For arsenic, the recommendation is for every three years.
        </p>

        <p>
          If you have any questions, please reach out to our team at 541-952-9254 or email us at <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
        </p>

        <p>
          Thank you again for taking the time to have your well tested. Getting your well tested helps protect the health
          of your family, pets, and the people in your community.
        </p>

        <p>
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254<br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov

        </p>

        <span>
          <span>Contact information for your county public health departments: </span>
          <br /> <br />

          <table style="width:100%; border: 0px;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Morrow County Public Health <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Umatilla County Public Health <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>

        </span>
      </body>
    </section>

    <!-- 0-5 Nitrate Spanish .-->
    <section *ngIf="nitrateLevel < 5" class="spanish-text">
      <span style="page-break-before: always;" class="page-break"></span>
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="spanish-text">
        <p>
          {{today | date: 'd MMMM, y':'':'es' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>Estimado/Estimada <span style='color:green; '>{{household?.contactName}}</span>:</p>

        <p>
          Gracias por solicitar una prueba gratuita de su agua de pozo doméstico. El agua subterránea en partes norteñas
          de los condados de Morrow y Umatilla está contaminada con nitrato a niveles que pueden dañar a la salud. Las
          personas pueden quedar expuestas al nitrato cuando usan agua de pozo contaminada para beber y cocinar. Los bebés
          alimentados con biberón y las mujeres embarazadas pueden sufrir daños incluso con exposiciones breves, y todos
          pueden experimentar daños con la exposición a largo plazo. La hoja informativa adjunta brinda más información
          sobre la exposición al nitrato y la salud.
        </p>

        <p>
          Hemos recibido resultados del pozo que provee agua para: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          <span>
            Nos complace informarle que el resultado de su prueba de nitrato de la muestra de agua recolectada el
            {{parameterResult.createdDate | date: 'd MMMM, y':'':'es' }}

            <span *ngIf="parameterResult.nitrateNd">
              no había nitrate detectable
            </span>

            <span *ngIf="!parameterResult.nitrateNd">
              Nos complace informarle que el resultado de su prueba de nitrato de la muestra de agua recolectada el
              {{parameterResult.createdDate | date: 'd MMMM, y':'':'es' }} fue de {{parameterResult.nitrateDisplay}} miligramos
              por
              litro de agua (mg/L)
            </span>

            indicado por la Agencia de Protección Ambiental (Environmental Protection Agency, EPA por sus siglas en inglés).

            <strong class="spanish-text-bold">El nivel de nitrato de su agua es seguro para beber, cocinar y todos los demás usos. </strong>
            <!-- <span *ngIf="!parameterResult.isRetest" class="spanish-text">Si se tomaron muestras del agua en más de una ubicación en la fecha mencionada anteriormente, proporcionamos el valor más bajo (generalmente después de
            la filtración).</span> -->
          </span>
        </p>

        <span *ngIf="!parameterResult.isRetest">
          <p>
            También disponemos de resultados del pozo respecto a la presencia de arsénico, coliformes totales, E. coli (tipos de bacteria) y plomo. Si alguno de estos resultados
            supera el límite de salud estipulado por la EPA, incluimos una hoja informativa para esa sustancia.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">arsénico</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.010 mg/L. Consulte
              la hoja informativa sobre el arsénico adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">plomo</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.015 mg/L. Consulte
              la hoja informativa sobre el plomo adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">no se encontraron</strong> coliformes totales (o bacterias) en su muestra de
              agua.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">encontraron coliformes totales (o bacterias)</strong> en su muestra de agua. Esta
              prueba puede
              detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no represente una
              contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la prueba de
              confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Su prueba mostró que la <strong class="spanish-text-bold">bacteria E. Coli no se encontró</strong> en su muestra de agua.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Su prueba mostró que <strong class="spanish-text-bold">se encontraron bacterias E. Coli</strong> en su muestra de agua. Esta prueba
              puede detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no
              represente una contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la
              prueba de confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>
        </span>
        <p *ngIf="!parameterResult.isRetest">
          Los resultados de la prueba también reflejan que el agua se analizó para la detección de manganeso, hierro y dureza.
          Necesitamos esta información para decidir cuál es el mejor sistema de tratamiento del agua para reducir los niveles de nitrato,
          en caso de que sea necesario. Estas sustancias no implican riesgos para la salud
        </p>
        <p *ngIf="parameterResult.isRetest">
          Los niveles de nitrato y otros contaminantes en el agua subterránea cambiarán con el tiempo. Como ocurre con cualquier pozo privado, le recomendamos
          que repita las pruebas del agua de pozo una vez al año para determinar
          la presencia de nitrato y demás contaminantes y controlar cualquier cambio. Para la detección de arsénico, se recomienda hacer pruebas cada tres años.
          <br />
        </p>
        <p *ngIf="!parameterResult.isRetest">
          Los niveles de nitrato y otros contaminantes en el agua subterránea cambian con el tiempo. Como ocurre con cualquier pozo privado,
          le recomendamos que repita las pruebas del agua de pozo una vez al año para detectar la presencia de nitrato y otros contaminantes y
          controlar cualquier cambio. Para la detección de arsénico, se recomienda realizar pruebas cada tres años. Basado en estos resultados,
          su hogar reúne los requisitos para recibir una prueba anual gratuita realizada por un laboratorio certificado.
          Usted recolectará la muestra de agua con equipo que le brindaremos y la llevará a un lugar de recolección designado; o bien, solicitará
          ayuda para la recolección del agua si no puede recolectarla por su cuenta. La OHA solo pagará la repetición de las pruebas de <u>nitrato</u>; usted
          deberá pagar las pruebas de otros contaminantes. Después de que se envíe la muestra al laboratorio, usted recibirá una copia del resultado de
          la prueba de parte del laboratorio y una carta de la OHA en la que se informa el resultado. Si no recibe los resultados después de 30 días,
          comuníquese con nosotros para que podamos enviarle el resultado.
        </p>

        <p>
          Si tiene alguna pregunta sobre esta información, comuníquese con nuestro equipo al 541-952-9254 o envíenos un
          correo electrónico a <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
        </p>

        <p>
          Nuevamente, le agradecemos por haber solicitado el análisis de su agua de pozo. Hacerse la prueba del pozo ayuda
          a proteger la salud de su familia, sus mascotas y su comunidad.
        </p>

        <p>
          Atentamente,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program - Programa de Seguridad de Pozos Domésticos <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov


        </p>

        <span>
          <span>Información de contacto de los departamentos de salud pública de su condado: </span>
          <table style="width:100%; border: 0px !important;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px !important;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Morrow <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Umatilla <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>


    <!-- 5-10 Nitrate English .-->
    <section *ngIf="nitrateLevel >= 5 && nitrateLevel < 10">
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="english-text">
        <p>
          {{today | date: 'MMMM d, y':'':'' }}
        </p>
        <p style='color:green'>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>Dear <span style='color:green; '>{{household?.contactName}}</span>:</p>

        <p>
          Thank you for taking the time to learn about the safety of your domestic well water. The groundwater in parts of northern Morrow and Umatilla Counties
          is contaminated with nitrate at levels that can harm health. People can become exposed to nitrate when they use contaminated well water for drinking and cooking.
          Formula-fed babies and pregnant women may suffer harm even from short exposures, and everyone may experience harm from long-term exposure.
          The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>

        <p>
          We have received results for the well providing water for: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          Your test results for nitrate from the water sample collected on {{parameterResult.createdDate | date: 'MMMM d,
          y':'':'' }} came in at
          {{parameterResult.nitrateDisplay}} milligrams per liter (mg/L) which is below the Environmental Protection Agency (EPA)
          safe water limit of 10 mg/L.
          <strong>Your water’s nitrate level is currently safe for drinking, cooking and all other uses. </strong>
          <!-- <i *ngIf="!parameterResult.isRetest">If your water was sampled in more than one location on the above date, we are reporting the lower value (usually after filtration).</i> -->
        </p>

        <!-- retest language -->
        <p *ngIf="parameterResult.isRetest">
          Although this is good news, your well is close to the EPA limit. Nitrate levels may change seasonally in the groundwater,
          so additional follow up is needed to make sure your well water remains safe. Based on these results, we will be reaching out
          quarterly to offer OHA-paid nitrate only retesting for one year to ensure your water remains safe For nitrate test results
          above 5 mg/L but below the limit of 10 mg/L, OHA will pay for nitrate testing of your well once every 3 months for a
          year to see which season shows the highest nitrate level. After that, annual testing should be done once per year during the month with the highest result.
        </p>

        <p *ngIf="parameterResult.isRetest">
          After the collection of each quarterly sample, you should receive two letters: a copy of your test
          result from the certified lab, and a letter from OHA stating the result. If you do not receive them within 30 days after the sample was taken,
          please contact us so we can get the result to you.
        </p>

        <p *ngIf="parameterResult.isRetest">
          Nitrate and other contaminant levels in groundwater will change over time. As with any private well, we recommend that you repeat testing
          of your well once per year for nitrate and other contaminants to monitor any changes. For arsenic, the recommendation is for every three years.
        </p>

        <!-- initial language -->
        <p *ngIf="!parameterResult.isRetest">
          Although this is good news, your well is close to the EPA limit. Nitrate levels may change seasonally in the groundwater,
          so additional follow up is needed to make sure your well water remains in the safe range. For nitrate test results that fall above
          5 mg/L but below the limit of 10 mg/L, OHA will pay for <u>nitrate</u> testing for your well once every 3 months for a year to see which
          season shows the highest nitrate level. You will receive a call from our partners at the Oregon Department of Human Services (ODHS)
          to set up a sample collection appointment for each quarter following your initial test. After four quarterly tests (including this test),
          annual testing should be done once per year during the month with the highest result.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          After the collection of each quarterly sample, you should receive two letters: a copy of your test
          result from the certified lab, and a letter from OHA stating the result. If you do not receive them within 30 days after the sample was taken,
          please contact us so we can get the result to you.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          As with any private well, in addition to nitrate, OHA recommends that you test your well once per year for total coliform and E. coli
          contaminants to monitor any changes. For arsenic, the recommendation is every three years.
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            We also have results for your well about arsenic, total coliform and E. coli (types of bacteria) and lead. If
            any of these results are above the health limit set by EPA, we are including a fact sheet for that substance.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Your test showed that your water sample had no detectable <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>above</strong> the EPA limit of 0.010 mg/L. Please see the
              attached arsenic fact sheet.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Your test showed that your water sample had no detectable <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>above</strong> the EPA limit of 0.015 mg/L. Please see the attached
              lead fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>found</strong> in your water
              sample. This test can easily pick up bacteria during the sample collection process and might not represent
              well contamination. We recommend you contact a lab to repeat the test for confirmation at your own expense.
              Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>found</strong> in your water sample. This test can easily pick up bacteria
              during the sample collection process and might not represent well contamination. We recommend you contact a
              lab to repeat test for confirmation at your own expense. Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>
          <p>
            Your test results also reflect that your water was tested for <strong>manganese</strong>, <strong>iron</strong>
            and <strong>hardness</strong>. We need this information to help decide the best water treatment system to reduce
            nitrate, should one be needed. These do not carry any health risks.
          </p>
        </span>

        <p>
          If you have any questions, please reach out to our team at 541-952-9254, email us at <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>, or reach out to
          your
          County public health department.
        </p>
        <p>
          Thank you again for taking the time to have your well tested. Getting your well tested helps protect the health
          of your family, pets, and the people in your community.
        </p>

        <p>
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov


        </p>

        <p>
          <strong>P.S. Important note: boiling water kills bacteria, but boiling water does not eliminate nitrate!</strong>
        </p>
        <span>
          <span>Contact information for your county public health departments: </span>
          <br /> <br />
          <table style="width:100%; border: 0px;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Morrow County Public Health <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Umatilla County Public Health <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>

      </body>
    </section>

    <!-- 5-10 Nitrate Spanish .-->
    <section *ngIf="nitrateLevel >= 5 && nitrateLevel < 10" class="spanish-text">
      <span style="page-break-before: always;" class="page-break"></span>
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="spanish-text">
        <p>
          {{today | date: 'd MMMM, y':'':'es' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>
          Estimado/Estimada <span style='color:green; '>{{household?.contactName}}</span>:
        </p>

        <p>
          Gracias por tomarse el tiempo para aprender sobre la seguridad del agua de su pozo doméstico.
          En algunas partes de los condados de Morrow y Umatilla en el norte del estado, el agua subterránea está contaminada
          con nitrato en niveles que pueden producir daños para la salud. Las personas pueden quedar expuestas al nitrato
          cuando usan agua de pozo contaminada para beber y cocinar. Los bebés alimentados con leche de fórmula y las mujeres
          embarazadas pueden sufrir daños incluso si están expuestos por poco tiempo, y todos pueden sufrir daños por exposiciones a largo plazo.
          En la hoja informativa adjunta, encontrará más información sobre la exposición al nitrato y la salud.
        </p>

        <p>
          Hemos recibido resultados del pozo que provee agua para: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          Los resultados de la prueba de nitrato de la muestra de agua recolectada el {{parameterResult.createdDate |
          date: 'd MMMM, y':'':'es' }} es de
          {{parameterResult.nitrateDisplay}} miligramos por litro (mg/l), lo que está por debajo del límite de agua segura de 10 mg/l indicado por la
          Agencia de Protección Ambiental (Environmental Protection Agency, EPA por sus siglas en inglés).
          <strong class="spanish-text-bold">El nivel de nitrato de su agua es actualmente seguro para beber, cocinar y todos los demás usos. </strong>
          <!-- <span *ngIf="!parameterResult.isRetest" class="spanish-text">Si se tomaron muestras del agua en más de una ubicación en la fecha mencionada anteriormente, proporcionamos el valor más bajo (generalmente después de la
          filtración).</span> -->
        </p>

        <!-- retest language -->
        <p *ngIf="parameterResult.isRetest">
          Si bien esta es una buena noticia, su pozo está cerca del límite de la EPA. Los niveles de nitrato en el agua subterránea pueden cambiar según la estación.
          Por lo tanto, es necesario realizar un seguimiento adicional para garantizar que el agua de su pozo se mantenga dentro del rango seguro. Basado en estos resultados,
          nos comunicaremos con usted trimestralmente para ofrecerle la repetición de pruebas exclusivas de nitrato durante un año, pagadas por la OHA, para garantizar que el
          agua se encuentre en un rango seguro. Para los resultados de la prueba de nitrato que superen los 5 mg/l, pero que se encuentren por debajo del límite de 10 mg/l,
          la OHA pagará las pruebas de nitrato de su pozo una vez cada 3 meses durante un año a fin de determinar en qué estación se presenta el nivel más elevado de nitrato.
          Después, se realizarán pruebas una vez al año durante el mes donde se observó el resultado más elevado.
        </p>

        <p *ngIf="parameterResult.isRetest">
          Después de la recolección de cada muestra trimestral, debe recibir dos cartas: una copia del resultado de la prueba del laboratorio certificado y una carta de la OHA,
          en la que se informa el resultado. Si no las recibe dentro de los 30 días posteriores a la recolección de la muestra, comuníquese con nosotros para que podamos enviarle
          el resultado.
        </p>
        <p *ngIf="parameterResult.isRetest">
          Los niveles de nitrato y otros contaminantes en el agua subterránea cambiarán con el tiempo. Como ocurre con cualquier pozo privado, le recomendamos que repita las
          pruebas del agua de pozo una vez al año para determinar la presencia de nitrato y demás contaminantes y controlar cualquier cambio. Para la detección de arsénico,
          se recomienda hacer pruebas cada tres años.
        </p>

        <!-- initial test language -->
        <p *ngIf="!parameterResult.isRetest">
          Si bien esta es una buena noticia, su pozo está cerca del límite de la EPA. Los niveles de nitrato en el agua subterránea pueden cambiar según la estación, de manera que es
          necesario realizar un seguimiento adicional para garantizar que el agua de su pozo se mantenga dentro del rango seguro. Para los resultados de la prueba de nitrato que están
          por encima de 5 mg/l pero por debajo del límite de 10 mg/l, la Oregon Health Authority (OHA) pagará las pruebas de <u>nitrato</u> para su pozo una vez cada 3 meses durante un año
          para ver qué estación muestra el nivel más alto de nitrato. Recibirá una llamada de nuestros socios del Departamento de Servicios Humanos de Oregon
          (Oregon Department of Human Services, ODHS por sus siglas en inglés) para programar una cita de recolección de muestras para cada trimestre después de la prueba inicial.
          Después de las cuatro pruebas trimestrales (incluida esta prueba), deberán realizarse pruebas anuales una vez al año durante el mes en el que se registró el resultado más alto.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Después de la recolección de cada muestra trimestral, debe recibir dos cartas: una copia del resultado de la prueba de parte del laboratorio certificado y una carta de la OHA en
          la que se informa el resultado. Si no las recibe dentro de los 30 días posteriores a la recolección de la muestra, comuníquese con nosotros para que podamos enviarle el resultado.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Como sucede con cualquier pozo privado, además de las pruebas de nitrato, la OHA recomienda que realice pruebas de contaminantes coliformes totales y E. coli en su pozo una vez al
          año para controlar los cambios. Para la detección de arsénico, se recomienda realizar pruebas cada tres años.
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            También disponemos de resultados del pozo respecto a la presencia de arsénico, coliformes totales, E. coli (tipos de bacteria) y plomo. Si alguno de estos resultados supera el límite
            de salud estipulado por la EPA, incluimos una hoja informativa para esa sustancia.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">arsénico</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.010 mg/L. Consulte
              la
              hoja informativa sobre el arsénico adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">plomo</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.015 mg/L. Consulte
              la hoja informativa sobre el plomo adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">no se encontraron</strong> coliformes totales (o bacterias) en su muestra de
              agua.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">encontraron coliformes totales (o bacterias)</strong> en su muestra de agua. Esta
              prueba puede
              detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no represente una
              contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la prueba de
              confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Su prueba mostró que la <strong class="spanish-text-bold">bacteria E. Coli no se encontró</strong> en su muestra de agua.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Su prueba mostró que <strong class="spanish-text-bold">se encontraron bacterias E. Coli</strong> en su muestra de agua. Esta prueba
              puede detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no
              represente una contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la
              prueba de confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>
          </p>

          <p>
            Los resultados de la prueba también reflejan que el agua se analizó para la detección de <strong class="spanish-text-bold">manganeso</strong>, <strong
              class="spanish-text-bold">hierro</strong> y <strong class="spanish-text-bold">dureza</strong>.
            Necesitamos esta información para decidir cuál es el mejor sistema de tratamiento del agua para reducir los niveles de nitrato,
            en caso de que sea necesario. Estas sustancias no implican riesgos para la salud.
          </p>
        </span>
        <p>
          Si tiene alguna pregunta sobre esta información, comuníquese con nuestro equipo al 541-952-9254 o envíenos un
          correo electrónico a <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
        </p>
        <p>
          Le agradecemos nuevamente por dedicar tiempo a la realización de pruebas de su pozo. Esto ayuda a proteger la salud de su familia, sus mascotas y las personas de su comunidad.
        </p>

        <p>
          Atentamente,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program - Programa de Seguridad de Pozos Domésticos <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov


        </p>

        <p>
          <strong class="spanish-text-bold">PD: Nota importante: El agua hervida destruye bacterias, pero no elimina la presencia de nitrato.</strong>
        </p>


        <span>
          <span>Contact information for your county public health departments: </span>
          <br /> <br />

          <table style="width:100%; border: 0px;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Morrow County Public Health <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Umatilla County Public Health <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>


    <!-- 10-25 Nitrate English .-->
    <section *ngIf="nitrateLevel >= 10 && nitrateLevel < 25">
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="english-text">
        <p>
          {{today | date: 'MMMM d, y':'':'' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>Dear <span style='color:green; '>{{household?.contactName}}</span>:</p>

        <p>
          Thank you for taking the time to learn about the safety of your domestic well water. The groundwater in parts of northern Morrow and Umatilla
          Counties is contaminated with nitrate at levels that can harm health. People can become exposed to nitrate when they use contaminated well
          water for drinking and cooking. Formula-fed babies and pregnant women may suffer harm even from short exposures, and everyone may experience
          harm from long-term exposure. The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>

        <p>
          We have received results for the well providing water for: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          We are sorry to report that your test results for nitrate from the water sample collected on
          {{parameterResult.createdDate | date: 'MMMM d, y':'':'' }} came in at {{parameterResult.nitrateDisplay}} milligrams per liter (mg/L)
          which is <strong>ABOVE</strong> the Environmental Protection Agency (EPA) safe water limit of 10 mg/L.
          <!-- <i *ngIf="!parameterResult.isRetest">If your water was sampled in more than one location on the above date, we are reporting the lower value (usually after filtration).</i> -->
        </p>
        <!-- retest language -->
        <p style='color:red;' *ngIf="parameterResult.isRetest">
          <strong>
            <u>This means that untreated water from your well is currently UNSAFE for drinking and cooking. </u>
          </strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          This is especially dangerous for any pregnant women and formula-fed infants in your household. Breastfeeding protects infants from harmful levels of nitrate exposure.
          However, it is important that your household <strong>does not make formula with your well water</strong> . Nitrate reduces the ability of blood to carry oxygen and can lead to a
          dangerous condition for infants called blue baby syndrome. You should immediately get bottled water to use for any infant formula. There is some evidence that
          exposure to high nitrate during pregnancy can also increase the risk of miscarriage. Young children who swallow water when brushing teeth should also use bottled
          water for toothbrushing until they learn to spit.
        </p>

        <p *ngIf="parameterResult.isRetest">
          <strong>Important note: boiling water kills bacteria, but boiling water does not eliminate nitrate!</strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          If this is the first time the nitrate in your water has tested above 10 mg/L, you will be contacted by someone from your County Health Department or the
          Oregon Health Authority to sign you up for a free supply of bottled drinking water. We may be able to install a free water filter system at your home in the future.
          This would be a reverse osmosis treatment system attached to a sink in your home that is certified to reduce nitrate to a safe level when nitrate contamination is
          between 10 mg/L and 25 mg/L. If you have previously tested between 10 and 25 mg/L for nitrate, you should have received a free supply of bottled drinking water
          and a reverse osmosis system installation or be on the list to receive one soon. After installation, we will also offer free filter changes, at which time we
          will retest your water for nitrate.
        </p>

        <!-- initial langulage -->
        <p style='color:red;' *ngIf="!parameterResult.isRetest">
          <strong>
            <u>This means that the water from your well is currently UNSAFE for drinking and cooking.</u>
          </strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          This is especially dangerous for any pregnant women and formula-fed infants in your household. Breastfeeding protects infants from harmful levels of nitrate exposure.
          However, it is important that your household does not make formula with your well water. Nitrate reduces the ability of blood to carry oxygen and can lead to a
          dangerous condition for infants called blue baby syndrome. You should immediately get bottled water to use for any infant formula.
          There is some evidence that exposure to high nitrate during pregnancy can also increase the risk of miscarriage.
          Young children who swallow water when brushing teeth should also use bottled water for toothbrushing until they learn to spit.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          <strong>Important note: boiling water kills bacteria, but boiling water does not eliminate nitrate!</strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          You will be contacted by someone from your County Health Department or the Oregon Health Authority to sign you up for a free supply of bottled drinking water.
          We may be able to install a free water filter system at your home in the future. This would be a reverse osmosis treatment system attached to a sink in your home
          that is certified to reduce nitrate to safe level when nitrate contamination is between 10 mg/L and 25 mg/L. After installation, we will also offer free filter changes,
          at which time we will retest your water for nitrate.
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            We also have results for your well about arsenic, total coliform and E. coli (types of bacteria) and lead. If any of these results are above the health limit set by EPA,
            we are including a fact sheet for that substance.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Your test showed that your water sample had no detectable <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>above</strong> the EPA limit of 0.010 mg/L. Please see the
              attached arsenic fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Your test showed that your water sample had no detectable <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>above</strong> the EPA limit of 0.015 mg/L. Please see the attached
              lead fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>found</strong> in your water
              sample. This test can easily pick up bacteria during the sample collection process and might not represent
              well contamination. We recommend you contact a lab to repeat the test for confirmation at your own expense.
              Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>found</strong> in your water sample. This test can easily pick up bacteria during the sample collection process and
              might not represent well contamination. We recommend you contact a lab to repeat test for confirmation at your own expense. Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            Your test results also reflect that your water was tested for <strong>manganese</strong>, <strong>iron</strong>
            and <strong>hardness</strong>. We need this information to help decide the best water treatment system to reduce
            nitrate, should one be needed. These do not carry any health risks.
          </p>
        </span>
        <p>
          Nitrate and other contaminant levels in groundwater will change over time. As with any private well, we recommend that you repeat testing of your
          well once per year for nitrate and other contaminants to monitor any changes. For arsenic, the recommendation is for every three years.
        </p>
        <p>
          If you have any questions, please reach out to our team at 541-952-9254 or email us at <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>. Thank you
          again
          for
          taking the time to have your well tested. Getting your well tested helps protect the health of your family,
          pets, and the people in your community.
        </p>

        <p>
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov


        </p>

        <span>
          <span>Contact information for your county public health departments: </span>
          <br /> <br />
          <table style="width:100%; border: 0px;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Morrow County Public Health <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Umatilla County Public Health <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>

    <!-- 10-25 Nitrate Spanish .-->
    <section *ngIf="nitrateLevel >= 10 && nitrateLevel < 25" class="spanish-text">
      <span style="page-break-before: always;" class="page-break"></span>
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="spanish-text">
        <p>
          {{today | date: 'd MMMM, y':'':'es' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>
          Estimado/Estimada <span style='color:green; '>{{household?.contactName}}</span>:
        </p>

        <p>
          Gracias por tomarse el tiempo para aprender sobre la seguridad del agua de su pozo doméstico. En algunas partes del norte de los condados de Morrow y Umatilla,
          el agua subterránea está contaminada con nitrato en niveles que pueden producir daños para la salud. Las personas pueden quedar expuestas al nitrato cuando usan
          agua de pozo contaminada para beber y cocinar. Los bebés alimentados con leche de fórmula y las mujeres embarazadas pueden sufrir daños incluso si están expuestos
          por poco tiempo, y todos pueden sufrir daños por exposiciones a largo plazo. En la hoja informativa adjunta, encontrará más información sobre la exposición al nitrato y la salud.
        </p>

        <p>
          Hemos recibido resultados del pozo que provee agua para: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          Lamentamos informarle que los resultados de las pruebas de nitrato de la muestra de agua recolectada el
          {{parameterResult.createdDate | date: 'd MMMM, y':'':'es' }} fueron de {{parameterResult.nitrateDisplay}}miligramos por litro (mg/l),
          lo que <strong class="spanish-text-bold">SUPERA</strong> el límite de agua segura de 10 mg/l indicado por la Agencia de Protección Ambiental (Environmental Protection Agency, EPA por sus
          siglas en inglés).
          <!-- <span *ngIf="!parameterResult.isRetest">Si se tomaron muestras del agua en más de una ubicación en la fecha mencionada anteriormente, proporcionamos el valor más bajo (por lo general, después de
          la filtración).</span> -->
        </p>

        <!-- retest language -->
        <p style='color:red;' *ngIf="parameterResult.isRetest">
          <strong class="spanish-text-bold">
            <u>Esto significa que el agua no tratada de su pozo actualmente NO ES SEGURA para beber o cocinar. </u>
          </strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          Esto resulta principalmente peligroso para las mujeres embarazadas y los bebés alimentados con leche de fórmula que vivan en su hogar.
          La lactancia protege a los bebés de los niveles dañinos de la exposición al nitrato. Sin embargo, es importante que los miembros del hogar no preparen
          leche de fórmula con el agua de pozo. El nitrato reduce la capacidad de la sangre para transportar oxígeno y puede provocar una condición peligrosa en
          los bebés denominada síndrome del bebé azul. Es recomendable que consiga de inmediato agua embotellada para preparar cualquier fórmula para bebés.
          Existe cierta evidencia de que la exposición a niveles elevados de nitrato durante el embarazo también puede aumentar el riesgo de sufrir un aborto espontáneo.
          Los niños pequeños que tragan agua cuando se cepillan los dientes también deben usar agua embotellada para el cepillado de dientes hasta que aprendan a escupir.
        </p>

        <p *ngIf="parameterResult.isRetest">
          <strong class="spanish-text-bold">Nota importante: El agua hervida destruye bacterias, pero no elimina la presencia de nitrato.</strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          Si esta es la primera vez que el nivel de nitrato en el agua da un resultado superior a 10 mg/l, una persona del Departamento de Salud del Condado o de la
          Oregon Health Authority se pondrá en contacto con usted para inscribirle a fin de que reciba una entrega gratuita de agua potable embotellada. En el futuro,
          podemos instalar un sistema de filtración de agua gratuito en su hogar. Esto sería un sistema de tratamiento por ósmosis inversa conectado a un fregadero en su hogar,
          que está certificado para reducir el nitrato a un nivel seguro cuando la contaminación por esta sustancia está entre 10 mg/l y 25 mg/l. Si el resultado anterior de
          la prueba fue de entre 10 y 25 mg/l para el nivel de nitrato, usted debe haber recibido una entrega gratuita de agua potable embotellada y debe tener instalado un
          sistema de ósmosis inversa o estar en la lista para recibir un sistema pronto. Después de la instalación, también ofreceremos cambios de filtro gratuitos y en ese
          momento realizaremos nuevas pruebas de nitrato en su agua.
        </p>


        <!-- initial language -->
        <p style='color:red;' *ngIf="!parameterResult.isRetest">
          <strong class="spanish-text-bold">
            <u>Esto significa que el agua de su pozo actualmente NO ES SEGURA para beber y cocinar.</u>
          </strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Esto resulta principalmente peligroso para las mujeres embarazadas y los bebés que se alimentan con leche de fórmula que vivan en su hogar.
          La lactancia protege a los bebés de los niveles dañinos de exposición al nitrato. Sin embargo, es importante que los miembros del hogar no preparen leche
          de fórmula con el agua de pozo. El nitrato reduce la capacidad de la sangre para transportar oxígeno y puede provocar una condición peligrosa en los bebés denominada
          el síndrome del bebé azul. Es recomendable que consiga de inmediato agua embotellada para preparar cualquier fórmula para bebés. Existe cierta evidencia de que la
          exposición a niveles elevados de nitrato durante el embarazo también puede aumentar el riesgo de sufrir un aborto espontáneo.
          Los niños pequeños que tragan agua cuando se cepillan los dientes también deben usar agua embotellada para el cepillado de dientes hasta que aprendan a escupir.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          <strong class="spanish-text-bold">Nota importante: El agua hervida destruye bacterias, pero no elimina la presencia de nitrato.</strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Una persona del Departamento de Salud del Condado o de la Oregon Health Authority se pondrá en contacto con usted para inscribirle a fin de que reciba una entrega
          gratuita de agua potable embotellada. En el futuro, podemos instalar un sistema de filtración de agua gratuito en su hogar. Este sería un sistema de tratamiento
          de ósmosis inversa conectado a un fregadero en su hogar, certificado para reducir el nitrato a un nivel seguro cuando la contaminación por esta sustancia está entre
          10 mg/l y 25 mg/l. Después de la instalación, también ofreceremos cambios de filtro gratuitos y en ese momento realizaremos nuevas pruebas de nitrato en su agua.
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            También disponemos de resultados del pozo respecto a la presencia de arsénico, coliformes totales, E. coli (tipos de bacteria) y plomo.
            Si alguno de estos resultados supera el límite saludable estipulado por la EPA, incluiremos una hoja informativa para esa sustancia.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">arsénico</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.010 mg/L. Consulte
              la
              hoja informativa sobre el arsénico adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">plomo</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.015 mg/L. Consulte
              la hoja informativa sobre el plomo adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">no se encontraron</strong> coliformes totales (o bacterias) en su muestra de
              agua.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">encontraron coliformes totales (o bacterias)</strong> en su muestra de agua. Esta
              prueba puede
              detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no represente una
              contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la prueba de
              confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Su prueba mostró que la <strong class="spanish-text-bold" g>bacteria E. Coli no se encontró</strong> en su muestra de agua.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Su prueba mostró que <strong class="spanish-text-bold">se encontraron bacterias E. Coli</strong> en su muestra de agua. Esta prueba
              puede detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no
              represente una contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la
              prueba de confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            Los resultados de la prueba también reflejan que el agua se analizó para la detección de <strong class="spanish-text-bold">manganeso</strong>, <strong
              class="spanish-text-bold">hierro</strong> y <strong class="spanish-text-bold">dureza</strong>.
            Necesitamos esta información para decidir cuál es el mejor sistema de tratamiento del agua para reducir los niveles de nitrato,
            en caso de que sea necesario. Estas sustancias no implican riesgos para la salud.
          </p>
        </span>
        <p>
          Los niveles de nitrato y otros contaminantes en el agua subterránea cambiarán con el tiempo. Como ocurre con cualquier pozo privado,
          le recomendamos que repita las pruebas del agua de pozo una vez al año para determinar la presencia de nitrato y demás contaminantes y
          controlar cualquier cambio. Para la detección de arsénico, se recomienda hacer pruebas cada tres años.
        </p>
        <p>
          Si tiene alguna pregunta, comuníquese con nuestro equipo llamando al 541-952-9254 o enviando un correo electrónico a
          <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
          Le agradecemos nuevamente por dedicar tiempo a la realización de pruebas de su pozo. Esto es una medida importante para proteger
          la salud de su familia, sus mascotas y las personas de su comunidad.
        </p>

        <p>
          Atentamente,<br />
          Oregon Health Authority<br />
          Programa de Seguridad de Pozos Domésticos <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov

        </p>

        <span>
          <span>Información de contacto de los departamentos de salud pública de su condado: </span>
          <table style="width:100%; border: 0px !important;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px !important;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Morrow <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Umatilla <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>


    <!-- 25+ Nitrate English -->
    <section *ngIf="nitrateLevel >= 25">
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="english-text">
        <p>
          {{today | date: 'MMMM d, y':'':'' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>Dear <span style='color:green; '>{{household?.contactName}}</span>:</p>

        <p>
          Thank you for taking the time to learn about the safety of your domestic well water. The groundwater in parts of northern Morrow and Umatilla Counties
          is contaminated with nitrate at levels that can harm health. People can become exposed to nitrate when they use contaminated well water for drinking and cooking.
          Formula-fed babies and pregnant women may suffer harm even from short exposures, and everyone may experience harm from long-term exposure.
          The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>

        <p>
          We have received results for the well providing water for: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          We are sorry to report your test results for nitrate from the water sample collected on
          {{parameterResult.createdDate | date: 'MMMM d, y':'':'' }} came in at {{parameterResult.nitrateDisplay}} milligrams per liter (mg/L) which far exceeds the
          Environmental Protection Agency (EPA) limit of 10 mg/L.
          <!-- <i *ngIf="!parameterResult.isRetest">If your water was sampled in more than one location on the above date, we are reporting the lower
            value
            (usually after filtration).</i> -->
        </p>

        <!-- retest language -->
        <p style='color:red;' *ngIf="parameterResult.isRetest">
          <strong>
            <u>This means that the water from your well is currently UNSAFE to drink or use for cooking.</u>
          </strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          This is especially dangerous for any pregnant women and infants in your household. If a woman drinks the water and then breastfeeds,
          that is safe for the infant. The mother’s body protects the nursing baby. However, it is important that your household <strong>does not make formula with your well water</strong>.
          Nitrate reduces the ability of blood to carry oxygen and can lead to a dangerous condition for infants called blue baby syndrome.
          You should immediately get bottled water to use for any infant formula. There is some evidence that exposure to high nitrate during pregnancy can also increase the
          risk of miscarriage. Young children who swallow water when brushing teeth should also use bottled water for toothbrushing until they learn to spit.
        </p>

        <p *ngIf="parameterResult.isRetest">
          <strong>Important note: boiling water can kill bacteria, but boiling water does not eliminate nitrate!</strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          If you are not already receiving free bottled drinking water, please contact your County Health Department
          or Oregon Health Authority. At the level you tested, OHA-provided treatment systems currently offered will not reduce nitrate to safe drinking levels,
          which is why we're offering free drinking water delivery until another solution can be determined.
        </p>

        <!-- initial language -->
        <p style='color:red;' *ngIf="!parameterResult.isRetest">
          <strong>
            <u>This means that the water from your well is currently UNSAFE to drink or use for cooking.</u>
          </strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          If you are not already receiving free bottled drinking water, please contact your County Health Department or Oregon Health Authority.
          At the level you tested, OHA-provided treatment systems currently offered will not reduce nitrate to safe drinking levels, which is why
          we're offering free drinking water delivery until another solution can be determined.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          This is especially dangerous for any pregnant women and infants in your household. If a woman drinks the water and then breastfeeds, that is safe for the infant.
          The mother’s body protects the nursing baby. However, it is important that your household <strong>does not make formula with your well water</strong>.
          Nitrate reduces the ability of blood to carry oxygen and can lead to a dangerous condition for infants called blue baby syndrome.
          You should immediately get bottled water to use for any infant formula. There is some evidence that exposure to high nitrate during pregnancy
          can also increase the risk of miscarriage. Young children who swallow water when brushing teeth should also use bottled water for toothbrushing until they learn to spit.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          <strong>Important note: boiling water can kill bacteria, but boiling water does not eliminate nitrate!</strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          You will be contacted by someone from your County Health Department or the Oregon Health Authority to sign you up for a free supply of bottled drinking water.
          At the level you tested, OHA-provided treatment systems currently offered will not reduce nitrate to safe drinking levels, which is why we're offering free
          drinking water delivery until another solution can be determined.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Based on these results, your household is also eligible to receive a free annual certified laboratory nitrate-only test by either collecting your own water sample
          using a kit we will provide for you and turning it in to a designated collection site, or by requesting assistance to collect the water if you cannot collect it yourself.
          After that sample is submitted to the lab, you will receive two letters: a copy of your test result from the certified lab, and a letter similar to this one from OHA
          stating the result. If you don't receive your results after 30 days, please contact us so we can get the result to you.
        </p>
        <span *ngIf="!parameterResult.isRetest">
          <p>
            We also have results for your well about arsenic, total coliform and E. coli (types of bacteria) and lead. If any of these results are above the health limit set by EPA, we are including a
            fact sheet for that substance.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Your test showed that your water sample had no detectable <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>below</strong> the EPA limit of 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Your test showed that your water sample has {{parameterResult.arsenic}} mg/l of <strong>arsenic</strong>, which is <strong>above</strong> the EPA limit of 0.010 mg/L. Please see the
              attached arsenic fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Your test showed that your water sample had no detectable <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>below</strong> the EPA limit of 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Your test showed that your water sample has {{parameterResult.lead}} mg/l of <strong>lead</strong>, which is <strong>above</strong> the EPA limit of 0.015 mg/L. Please see the attached
              lead fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Your test showed that <strong>total coliform (or bacteria)</strong> was <strong>found</strong> in your water
              sample. This test can easily pick up bacteria during the sample collection process and might not represent
              well contamination. We recommend you contact a lab to repeat the test for confirmation at your own expense.
              Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>not found</strong> in your water sample.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Your test showed that <strong>E. Coli bacteria</strong> were <strong>found</strong> in your water sample. This test can easily pick up bacteria during the sample collection process and
              might not represent well contamination. We recommend you contact a lab to repeat test for confirmation at your own expense. Please see the attached coliform bacteria fact sheet.
            </span>

            <br />
          </p>

          <p>
            Your test results also reflect that your water was tested for <strong>manganese</strong>, <strong>iron</strong> and <strong>hardness</strong>.
            We need this information to help decide the best water treatment system to reduce nitrate, should one be needed. These do not carry any health risks.
          </p>
        </span>
        <p>
          Nitrate and other contaminant levels in groundwater will change over time. As with any private well, we recommend that you repeat testing of your well
          once per year for nitrate and other contaminants to monitor any changes. For arsenic, the recommendation is for every three years.
        </p>

        <p>
          If you have any questions, please reach out to our team at 541-952-9254 or email us at <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
        </p>
        <p>
          Thank you again for taking the time to have your well tested. Getting your well tested is an important step to protecting the health of your family,
          pets, and the people in your community.
        </p>

        <p>
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov


        </p>

        <span><br />
          <span>Contact information for your county public health departments: </span>
          <br /> <br />

          <table style="width:100%; border: 0px;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Morrow County Public Health <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Umatilla County Public Health <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>

    <!-- 25+ Nitrate Spanish .-->
    <section *ngIf="nitrateLevel >= 25" class="spanish-text">
      <span style="page-break-before: always;" class="page-break"></span>
      <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
      </Header>
      <style>
        td,
        th {
          border: 1px solid #dddddd;
          margin-left: 5.4pt;
          padding: 0in 5.4pt 0in 5.4pt
        }
      </style>

      <body class="spanish-text">
        <p>
          {{today | date: 'd MMMM, y':'':'es' }}
        </p>
        <p style='color:green; '>
          {{household?.contactName}}<br>
          {{household?.mailingAddress}}<br>
          {{household?.mailingCity}}, {{household?.mailingState}} {{household?.mailingZip}}
        </p>
        <p></p>
        <p></p>
        <p>
          Estimado/Estimada <span style='color:green; '>{{household?.contactName}}</span>:
        </p>

        <p>
          Gracias por tomarse el tiempo para aprender sobre la seguridad del agua de su pozo doméstico. En algunas partes del norte de los condados de Morrow y Umatilla,
          el agua subterránea está contaminada con nitrato en niveles que pueden producir daños para la salud. Las personas pueden quedar expuestas al nitrato cuando usan
          de pozo contaminada para beber y cocinar. Los bebés alimentados con leche de fórmula y las mujeres embarazadas pueden sufrir daños incluso si están expuestos por poco tiempo,
          y todos pueden sufrir daños por exposiciones a largo plazo. En la hoja informativa adjunta, encontrará más información sobre la exposición al nitrato y la salud.
        </p>

        <p>
          Hemos recibido resultados del pozo que provee agua para: {{household?.address1}}, {{household?.city}},
          {{household?.state}} {{household?.zip}}.
        </p>

        <p>
          Lamentamos informarle que los resultados de las pruebas de nitrato de la muestra de agua recolectada el
          {{parameterResult.createdDate | date: 'd MMMM, y':'':'es' }} fue de {{parameterResult.nitrateDisplay}}
          miligramos por litro (mg/l), lo que SUPERA el límite de agua segura de 10 mg/l indicado por la Agencia de Protección Ambiental
          (Environmental Protection Agency, EPA por sus siglas en inglés).
          <!-- <span *ngIf="!parameterResult.isRetest">Si se tomaron muestras del agua en más de una ubicación en la
          fecha mencionada anteriormente, proporcionamos el valor más bajo (por lo general, después de la filtración).</span> -->
        </p>

        <!-- retest language -->
        <p style='color:red;' *ngIf="parameterResult.isRetest">
          <strong class="spanish-text-bold">
            <u>Esto significa que el agua de su pozo actualmente NO ES SEGURA para beber o cocinar.</u>
          </strong>
        </p>
        <p *ngIf="parameterResult.isRetest">
          Esto resulta principalmente peligroso para las mujeres embarazadas y los bebés que vivan en su hogar. Si una mujer
          bebe el agua y luego amanta a su bebé, este no corre ningún peligro. El organismo de la madre protege al bebé lactante.
          Sin embargo, es importante que los miembros del hogar no preparen leche de fórmula con el agua de pozo. El nitrato reduce la capacidad
          de la sangre para transportar oxígeno y puede provocar una condición peligrosa en los bebés denominada síndrome del bebé azul.
          Es recomendable que consiga de inmediato agua embotellada para preparar cualquier fórmula para bebés. Existe cierta evidencia de
          que la exposición a niveles elevados de nitrato durante el embarazo también puede aumentar el riesgo de sufrir un aborto espontáneo.
          Los niños pequeños que tragan agua cuando se cepillan los dientes también deben usar agua embotellada para el cepillado de dientes hasta que aprendan a escupir.
        </p>

        <p *ngIf="parameterResult.isRetest">
          <strong class="spanish-text-bold">Nota importante: El agua hervida puede destruir bacterias, pero no elimina la presencia de nitrato.</strong>
        </p>

        <p *ngIf="parameterResult.isRetest">
          Si aún no está recibiendo agua potable embotellada gratuita, comuníquese con el Departamento de Salud del Condado o con la Oregon Health Authority.
          Para el nivel de nitrato que determinaron las pruebas, los sistemas de tratamiento proporcionados por la OHA que se ofrecen en la actualidad no
          reducirán la presencia de nitrato a niveles seguros para el consumo. Por ello, le ofrecemos el envío de agua potable gratuita hasta que se pueda determinar otra solución.
        </p>

        <!-- initial language -->
        <p style='color:red;' *ngIf="!parameterResult.isRetest">
          <strong class="spanish-text-bold">
            <u>Esto significa que el agua de su pozo actualmente NO ES SEGURA para beber y cocinar.</u>
          </strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Esto resulta principalmente peligroso para las mujeres embarazadas y los bebés que se alimentan con leche de fórmula que vivan en su hogar.
          La lactancia protege a los bebés de los niveles dañinos de exposición al nitrato. Sin embargo, es importante que los miembros del hogar
          no preparen leche de fórmula con el agua de pozo. El nitrato reduce la capacidad de la sangre para transportar oxígeno y puede provocar
          una condición peligrosa en los bebés denominada el síndrome del bebé azul. Es recomendable que consiga de inmediato agua embotellada
          para preparar cualquier fórmula para bebés. Existe cierta evidencia de que la exposición a niveles elevados de nitrato durante el
          embarazo también puede aumentar el riesgo de sufrir un aborto espontáneo. Los niños pequeños que tragan agua cuando se cepillan los
          dientes también deben usar agua embotellada para el cepillado de dientes hasta que aprendan a escupir.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          <strong class="spanish-text-bold">Nota importante: El agua hervida destruye bacterias, pero no elimina la presencia de nitrato.</strong>
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Una persona del Departamento de Salud del Condado o de la Oregon Health Authority se pondrá en contacto con usted para inscribirle a fin de
          que reciba una entrega gratuita de agua potable embotellada. En el futuro, podemos instalar un sistema de filtración de agua gratuito en su hogar.
          Este sería un sistema de tratamiento de ósmosis inversa conectado a un fregadero en su hogar, certificado para reducir el nitrato a un nivel seguro
          cuando la contaminación por esta sustancia está entre 10 mg/l y 25 mg/l. Después de la instalación, también ofreceremos cambios de filtro gratuitos
          y en ese momento realizaremos nuevas pruebas de nitrato en su agua.
        </p>

        <p *ngIf="!parameterResult.isRetest">
          Basado en estos resultados, su hogar también reúne los requisitos para recibir una prueba anual gratuita de detección exclusiva de nitrato realizada
          por un laboratorio certificado. Usted recolectará la muestra de agua con equipo que le brindaremos y la llevará a un lugar de recolección designado;
          o bien, solicitará ayuda para la recolección del agua si no puede recolectarla por su cuenta. Después de que se envíe la muestra al laboratorio,
          usted recibirá dos cartas: una copia del resultado de la prueba de parte del laboratorio certificado y una carta similar a esta, en la que la OHA le
          informará el resultado. Si no recibe los resultados después de 30 días, comuníquese con nosotros para que podamos enviarle el resultado.
        </p>

        <span *ngIf="!parameterResult.isRetest">
          <p>
            También disponemos de resultados del pozo respecto a la presencia de arsénico, coliformes totales, E. coli (tipos de bacteria) y plomo. Si alguno de estos resultados supera
            el límite saludable estipulado por la EPA, incluiremos una hoja informativa para esa sustancia.
          </p>

          <p>
            <span *ngIf="parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">arsénico</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="!parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.010 mg/L.
            </span>

            <span *ngIf="parameterResult.arsenicHigh && !parameterResult.arsenicNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.arsenic}} mg/l de
              <strong class="spanish-text-bold">arsénico</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.010 mg/L. Consulte
              la
              hoja informativa sobre el arsénico adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="parameterResult.leadNd">
              Su prueba mostró que su muestra de agua no había <strong class="spanish-text-bold">plomo</strong> detectable,
              que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="!parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong>plomo</strong>, que está por <strong class="spanish-text-bold">debajo del límite</strong> de la EPA de 0.015 mg/L.
            </span>

            <span *ngIf="parameterResult.leadHigh && !parameterResult.leadNd">
              Su prueba mostró que su muestra de agua tiene {{parameterResult.lead}} mg/l de
              <strong class="spanish-text-bold">plomo</strong>, que está por <strong class="spanish-text-bold">encima del límite</strong> de la EPA de 0.015 mg/L. Consulte
              la hoja informativa sobre el plomo adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">no se encontraron</strong> coliformes totales (o bacterias) en su muestra de
              agua.
            </span>

            <span *ngIf="parameterResult.hasTotalColiform">
              Su prueba mostró que <strong class="spanish-text-bold">encontraron coliformes totales (o bacterias)</strong> en su muestra de agua. Esta
              prueba puede
              detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no represente una
              contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la prueba de
              confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            <span *ngIf="!parameterResult.hasEcoli">
              Su prueba mostró que la <strong class="spanish-text-bold">bacteria E. Coli no se encontró</strong> en su muestra de agua.
            </span>

            <span *ngIf="parameterResult.hasEcoli">
              Su prueba mostró que <strong class="spanish-text-bold">se encontraron bacterias E. Coli</strong> en su muestra de agua. Esta prueba
              puede detectar fácilmente bacterias durante el proceso de recolección de muestras y es posible que no
              represente una contaminación del pozo. Le recomendamos que se comunique con un laboratorio para repetir la
              prueba de confirmación a su cargo. Consulte la hoja informativa sobre bacterias coliformes adjunta.
            </span>

            <br />
          </p>

          <p>
            Los resultados de la prueba también reflejan que el agua se analizó para la detección de manganeso, hierro y dureza.
            Necesitamos esta información para decidir cuál es el mejor sistema de tratamiento del agua para reducir los niveles de nitrato,
            en caso de que sea necesario. Estas sustancias no implican riesgos para la salud.
          </p>
        </span>
        <p>
          Los niveles de nitrato y otros contaminantes en el agua subterránea cambiarán con el tiempo. Como ocurre con cualquier pozo privado,
          le recomendamos que <strong class="spanish-text-bold">repita las pruebas del agua</strong> de pozo una vez al año para determinar la presencia de nitrato y demás contaminantes
          y controlar cualquier cambio. Para la detección de arsénico, se recomienda hacer pruebas cada tres años.
        </p>
        <p>
          Si tiene alguna pregunta, comuníquese con nuestro equipo llamando al 541-952-9254 o enviando un correo electrónico a
          <a href="mailto:Domestic.Wells@odhsoha.oregon.gov">Domestic.Wells@odhsoha.oregon.gov</a>.
          Le agradecemos nuevamente por dedicar tiempo a la realización de pruebas de su pozo. Esto es una medida importante para proteger
          la salud de su familia, sus mascotas y las personas de su comunidad.
        </p>

        <p>
          Atentamente,<br />
          Oregon Health Authority<br />
          Programa de Seguridad de Pozos Domésticos <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov

        </p>

        <span>
          <span>Información de contacto de los departamentos de salud pública de su condado: </span>
          <table style="width:100%; border: 0px !important;">
            <tr style="border: 0px;">
              <td style="width:50%; border: 0px;">
                <table style="border: 0px !important;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Morrow <br />
                      (541) 256-0514 <br />
                      mchealth@morrowcountyor.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Letter Header">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width:50%; border: 0px;">
                <table style="border: 0px;">
                  <tr style="border: 0px;">
                    <td style="border: 0px;">
                      Departamento de Salud Pública del condado de Umatilla <br />
                      (541) 278-6394 <br />
                      health@umatillacounty.gov
                    </td>
                    <td style="border: 0px;">
                      <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Letter Header">
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
          </table>
        </span>
      </body>
    </section>

  </ng-template>
</mat-dialog-content>